module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/en/2-f71339871936d5781e1e243a99449e87.jpg";